<template>
  <div class="grammar-sentences">
    <el-table ref="sentences" :data="sentences" style="width: 100%">
      <el-table-column type="expand" width="16">
        <template v-slot="scope">
          <SentenceForm v-model="sentences[scope.$index]" @change="changeSentence(scope.$index)" @cancel="closeExpand(scope)" :upload-image="uploadImage"></SentenceForm>
        </template>
      </el-table-column>
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column label="句子">
        <template v-slot="scope">
          <PinyinPreview :text="scope.row.text" :pinyin="scope.row.pinyin"></PinyinPreview>
        </template>
      </el-table-column>
      <el-table-column align="right" width="100">
        <template v-slot:header>
          <el-button type="primary" icon="el-icon-plus" @click="addSentence"></el-button>
        </template>
        <template v-slot="scope">
          <el-button @click="updateSentence(scope)" type="text" size="small">编辑</el-button>
          <el-button @click="deleteSentence(scope)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import SentenceForm from './SentenceForm'

export default {
  name: 'Sentences',
  components: {
    SentenceForm,
    PinyinPreview: require('@/components/PinyinPreview').default
  },
  props: {
    gid: Number,
    uploadImage: Boolean,
    sentences: {
      type: Array,
      default () {
        return []
      }
    }
  },
  watch: {
    gid () {
      this.initData()
    }
  },
  data () {
    return {
      deletedSentences: []
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      this.deletedSentences = []
      this.sentences.forEach((n, i) => {
        n.weight = i + 1;
        n.key = i;
      });
    },
    updateSentence (item) {
      this.$refs.sentences.toggleRowExpansion(item.row)
    },
    addSentence () {
      this.sentences.push({key: (new Date()).getTime(), weight: this.sentences.length + 1})
    },
    deleteSentence (item) {
      if (item.row.id) {
        this.deletedSentences.push({...item.row})
      }
      this.sentences.splice(item.$index, 1)
    },
    closeExpand (item) {
      this.$refs.sentences.toggleRowExpansion(item.row)
    },
    changeSentence(index) {
      const sentence = this.sentences[index];
      const offset = sentence.weight - index - 1;
      if (offset !== 0) {
        this.sentences.splice(index, 1);
        this.sentences.splice(sentence.weight - (offset > 0 ? 2 : 1), 0, sentence);
        this.sentences.forEach((n, i) => {
          if (n.weight !== i + 1) {
            n.weight = i + 1;
          }
        });
      }
    }
  }
}
</script>

<style lang="scss">
  .kewen-sentences{
    margin-top: -12px;
    .el-table__expanded-cell{
      padding: 20px 0;
      > .kewen-sentence-form >.el-form-item{
        margin-bottom: 15px;
      }
    }
  }
</style>

